import {
  AITools,
  CreditCostMap,
  FluxModel,
  MapSelectedAITools,
  WeddinglyModel,
} from "../../../../../../../../../../constant";
import IconAIToolsSelector from "./IcAIToolsSelector.svg";
import IconArrowDownWhite from "./IcArrowDownWhite.svg";
import ArrowRight from "../../../../../../../../../../../../../../Assets/Icons/arrow-right.svg";
import styles from "./AIToolsSelector.module.scss";
import React, { useState } from "react";
import Popper from "@mui/material/Popper";
import { useAIToolsContext } from "../../../../../../../../../../context/AIToolsProvider";
import { useADSContext } from "../../../../../../../../../../context/ADSProvider";
import BrushPink from "../../../../../../../../../../../../../../Assets/Icons/brush-pink.svg";
import { Typography } from "@mui/material";

const FluxKontext = "flux-kontext";

const AIToolsOptions = [
  FluxKontext,
  // AITools.RemoveBackground,
  // AITools.BlurBackground,
  // AITools.SwapFace,
  // AITools.FaceCorrection,
  // AITools.HighlightAndSwap,
  // AITools.HighlightAndSwap2,
  // AITools.HighlightAndRemove,
  // AITools.AvatarConverter,
];

const newMapSelectedAITools = {
  ...MapSelectedAITools,
  [FluxKontext]: {
    title: "WeddinglyAi Edit",
    description: "Prompt.Edit.Done",
    iconClassName: BrushPink,
    iconClassNameSelector: BrushPink,
    isImage: true,
  },
};

const emptySelectedAITools = {
  title: "AI Tools",
  description: "",
  iconClassName: IconAIToolsSelector,
  isImage: true,
};

const AIToolsSelector = () => {
  const {
    selectedAITools,
    setSelectedAITools,
    resetAITools,
    setFirstSelectedImageServerPath,
  } = useAIToolsContext();
  const {
    setForm,
    generalCategory,
    handleSelectProduct,
    selectedProduct,
    userInfo,
    setOutOfCreditsModal,
  } = useADSContext();

  const { iconClassName, title, isImage, iconClassNameSelector } =
    newMapSelectedAITools[selectedAITools] || emptySelectedAITools;

  const [anchorEl, setAnchorEl] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickAction = () => {
    if (selectedAITools) {
      resetAITools();
      handleSelectProduct(selectedProduct, null, true);
      return;
    }

    toggleDropdown();
  };

  const handleSelectAITools = (toolsName) => {
    setShowDropdown(false);

    if (toolsName === FluxKontext) {
      // Check for not enough credits
      const useCredit =
        CreditCostMap[FluxModel.FluxKontext] || CreditCostMap.others;
      const { balance } = userInfo.userCredit || {};
      if (balance < useCredit) {
        setOutOfCreditsModal({
          show: true,
          variant: "notEnoughCredits",
          reverseTitleColor: true,
        });
      }

      setForm((prev) => ({
        ...prev,
        model: FluxModel.FluxKontext,
        categoryId: prev.categoryId || generalCategory.id || 0,
        prompt: "",
      }));

      return;
    }

    setSelectedAITools(toolsName);

    const isHighlightAndSwap = [
      AITools.HighlightAndSwap,
      AITools.HighlightAndSwap2,
    ].includes(toolsName);
    setForm((prev) => ({
      ...prev,
      model: WeddinglyModel.StudioV1,
      categoryId: generalCategory.id || 0,
      ...(isHighlightAndSwap && { prompt: "" }),
    }));

    const isImageWithServerPath = [
      AITools.FaceCorrection,
      AITools.AvatarConverter,
    ].includes(toolsName);

    if (isImageWithServerPath) {
      const imagePath =
        selectedProduct.imageEditedUrl || selectedProduct.imageUrl || null;

      setFirstSelectedImageServerPath(imagePath);
    } else {
      setFirstSelectedImageServerPath(null);
    }
  };

  return (
    <div>
      {/*OVERLAY*/}
      {showDropdown && (
        <div
          className="overlay-no-blur"
          onClick={() => setShowDropdown(false)}
        />
      )}

      {/*TRIGGER FOR DROPDOWN*/}
      <div className={styles.trigger} ref={setAnchorEl}>
        <section
          className={styles.title}
          onClick={toggleDropdown}
          key={iconClassName}
        >
          {isImage ? (
            <img src={iconClassNameSelector || iconClassName} alt="icon" />
          ) : (
            <i className={"action-icon " + iconClassName}></i>
          )}
          {title}
        </section>

        <section
          className={styles.action}
          onClick={handleClickAction}
          key={selectedAITools}
        >
          {selectedAITools ? (
            <i className={`fas fa-times ${styles.icon}`} />
          ) : (
            <img src={IconArrowDownWhite} alt="icon" className={styles.icon} />
          )}
        </section>
      </div>

      {/*DROPDOWN ITEM*/}
      <Popper
        open={showDropdown}
        anchorEl={anchorEl}
        sx={{ zIndex: 3 }}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 10],
            },
          },
        ]}
      >
        <div className={styles.dropdownWrapper}>
          <Typography fontWeight={500} mb={2}>
            Choose an AI Edit Tool
          </Typography>
          <div className={styles.dropdown}>
            {AIToolsOptions.map((toolsName) => {
              const isActive = toolsName === selectedAITools;
              const aiToolsInfo = newMapSelectedAITools[toolsName];

              return (
                <div
                  key={toolsName}
                  className={`${styles.dropdownItem} ${
                    isActive ? styles.active : ""
                  }`}
                  onClick={() => handleSelectAITools(toolsName)}
                >
                  <img
                    src={BrushPink}
                    alt="icon"
                    className={styles.startIcon}
                  />

                  <div className={styles.detail}>
                    <p className={styles.title}>{aiToolsInfo.title}</p>
                    <p className={styles.desc}>{aiToolsInfo.description}</p>
                  </div>

                  <img
                    src={ArrowRight}
                    alt="icon"
                    className={styles.arrowRight}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Popper>
    </div>
  );
};

export default AIToolsSelector;
